import {AxiosPromise} from "axios";
import RequestHelper, {ActionAnswer, CommandData} from "../utils/RequestsHelper";

export default class ExportProductsApi {
    public static validate(): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("get", "export&action=validate")
    }

    public static data(): AxiosPromise<ActionAnswer<{ exportProducts: CommandData, showCommand: boolean }>> {
        return RequestHelper.send("get", "export&action=commandData")
    }

    public static start(): AxiosPromise<ActionAnswer<{ task_id: number }>> {
        return RequestHelper.send("post", "export&action=export", {})
    }

    public static exportData(): AxiosPromise<ActionAnswer<{categories_count: number, products_count: number}>> {
        return RequestHelper.send("post", "export&action=exportData", {})
    }
}